import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getApplicationLinks } from "../../actions/UrlActions";
import UrlHelper from "../../utilities/UrlHelper";

export class Header extends Component {
    constructor (props) {
        super(props);
        this.state = {};
        this.onSignOut = this.onSignOut.bind(this);
    }

    componentDidMount () {
        this.props.getApplicationLinks(this.props.showLoginPageUrls);
    }

    getFullName () {
        return this.props.hideLogout == null ? FullName : "";
    }

    getHospital () {
        return this.props.hideLogout == null ? HospitalName : "";
    }

    onSignOut () {
        window.location = UrlHelper.getLogoutUrl();
    }

    render () {
        var product = this.props.targetProduct == null ? "none" : "inline";

        return (<div id="header">
            <div id="applicationLinks" className="row">
                <div className="col-md-12">
                    <div style={{ float: "left" }}>
                        <ul className="list-inline">
                            <li><a id="s797Url" tabIndex="-1" href={this.props.appLinks.s797Url}>Simplifi 797</a></li>
                            <li>|</li>
                            <li><a id="quantifiUrl" tabIndex="-1" href={this.props.appLinks.quantifiUrl}>Quantifi </a>
                            </li>
                            <li>|</li>
                            <li><a id="sentri7url" tabIndex="-1" href={this.props.appLinks.sentri7Url}>Sentri7 </a></li>
                            <li>|</li>
                            <li><a id="staffReadyUrl" tabIndex="-1"
                                href={this.props.appLinks.staffReadyUrl}>StaffReady</a></li>
                            <li>|</li>
                            <li><a id="veriformUrl" tabIndex="-1" href={this.props.appLinks.veriformUrl}>VeriForm</a></li>
                            <li>|</li>
                            <li><a id="pocAdvisorUrl" tabIndex="-1" href={this.props.appLinks.pocAdvisorUrl}>Poc Advisor</a></li>
                        </ul>
                    </div>
                    <div className="list-inline" style={{ float: "right" }}>
                        {!this.props.hideLogout &&
                            <a id="logout" tabIndex="-1" onClick={() => this.onSignOut()} style={{ display: "inline" }}>
                                Sign Out
                            </a>
                        }
                    </div>
                </div>
            </div>
            <div id="LoginInfo" className="row">
                <div className="col-md-12">
                    <div>{this.getFullName()}</div>
                    <div>{this.getHospital()}</div>
                </div>
            </div>
            <div className="row logoRow">
                <div className="col-md-3">
                    <img className="logo"
                        src={UrlHelper.getIdentifiUrl() + "img/wk-brand.svg"} />
                </div>
                <div className="col-md-7">
                    <div id="sentri7">{this.props.targetProduct}<sup style={{ display: product }}>&reg;</sup></div>
                </div>
                <div className="col-md-2">&nbsp;</div>
            </div>
        </div>);
    }
}

Header.defaultProps = {
    appLinks: {},
    showLoginPageUrls: false
};

Header.propTypes = {
    hideLogout: PropTypes.bool,
    getApplicationLinks: PropTypes.func,
    showLoginPageUrls: PropTypes.bool
};

const mapStateToProps = state => ({
    state: state.emailLoginState,
    appLinks: state.appState.appLinks
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getApplicationLinks: (showLoginPageUrls) => dispatch(getApplicationLinks(showLoginPageUrls))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
